import "../../App.css";
import "../../Events.css";
import React, { useState, useEffect } from "react";
import NavMenuMobile from "./components/NavMenuMobile";
import { Helmet } from "react-helmet";
import { getLandingPageData } from "../../utils/api/helpers/pages";
import PageLoader from "../../utils/Ui/PageLoader";
import AnimatedGradientBackground from "../../utils/Actions/AnimatedGradientBackground";
import Footer from "../../components/Footer/Footer";

export default function HomeMobile() {
  const [isLoading, setIsLoading] = useState(true);
  const [homeData, setHomeData] = useState(null);

  useEffect(() => {
    getLandingPageData()
      .then((result) => {
        setHomeData(result.data.GenreList);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  return (
    <>
      <PageLoader isLoading={isLoading} />
      <div id="container" style={{ paddingTop: 70 }}>
        <Helmet>
          <title>Netflix Series FYC</title>
          <meta name="description" content="Netflix Series FYC" />
        </Helmet>

        <NavMenuMobile navData={homeData} />
        <Footer type={"home"} />
      </div>
      <AnimatedGradientBackground />
    </>
  );
}
